import { useEffect, type ReactNode } from 'react'
import { CartProvider } from '../lib/cart'
import { ToastProvider, useToast } from '../lib/toast'
import { useShared } from '../lib/i18n'
import { StoreHeader } from '../components/StoreHeader'
import { StoreFooter } from '../components/StoreFooter'
import { CartDrawer } from '../components/CartDrawer'
import { FloatingWhatsApp } from '../components/FloatingWhatsApp'

/** Surface server flash messages as toasts. */
function FlashBridge() {
  const { flash } = useShared()
  const { toast } = useToast()
  useEffect(() => {
    if (flash.notice) toast(flash.notice, 'success')
    if (flash.alert) toast(flash.alert, 'error')
  }, [flash.notice, flash.alert, toast])
  return null
}

export function StoreLayout({ children }: { children: ReactNode }) {
  return (
    <ToastProvider>
      <CartProvider>
        <FlashBridge />
        <div className="flex min-h-screen flex-col">
          <StoreHeader />
          <main className="flex-1">{children}</main>
          <StoreFooter />
        </div>
        <CartDrawer />
        <FloatingWhatsApp />
      </CartProvider>
    </ToastProvider>
  )
}
